import { Rating } from 'domain/types';

export function getRatingLabel(rating: Rating): string {
  switch (rating) {
    case 0:
      return `Highly risk resistant`;
    case 1:
      return `Risk resistant`;
    case 2:
      return `Moderate risk`;
    case 3:
      return `High risk`;
    case 4:
      return `Critical risk`;
  }
}
